export const FormatAmount = (amount) => {
  var number = parseFloat(Number(amount));
  var formattedAmount = number.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return formattedAmount;
};
